'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EDITOR_STORE_NAME = exports.EDITOR_STORE_NAME = 'editorStore';

// Actions Types
var EDITOR_STATE_CHANGED = exports.EDITOR_STATE_CHANGED = 'EDITOR_STATE_CHANGED';
var EDITOR_STYLE_COMMAND = exports.EDITOR_STYLE_COMMAND = 'EDITOR_STYLE_COMMAND';


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/store/editorConstants.js
// module id = 197
// module chunks = 0